import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MenuButtonProfileComponent } from './menuButtonProfile.component';
import { PlIconModule } from '@app/icon-library/lib/pl-icon.module';
import { TranslateModule } from '@ngx-translate/core';
import { PlPopoverModule } from '@app/components/pl-popover/pl-popover.module';

@NgModule({
  imports: [CommonModule, PlIconModule, TranslateModule, PlPopoverModule],
  declarations: [MenuButtonProfileComponent],
  exports: [MenuButtonProfileComponent],
})
export class MenuButtonProfileModule {}
